<template>
  <ActionButton mode="secondary" :actions="actions" :loading="loading" />
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { RygenMenuItem, Severity } from '@rygen/rygen-ui/model';

import ActionButton from '@rygen/rygen-ui/components/button/ActionButton.vue';

const props = defineProps({
  selectable: {
    type: Boolean,
    default: () => false,
  },
  dispatchable: {
    type: Boolean,
    default: () => false,
  },
  cancellable: {
    type: Boolean,
    default: () => false,
  },
  resendable: {
    type: Boolean,
    default: () => false,
  },
  loading: {
    type: Boolean,
    default: () => false,
  },
});
const { cancellable, dispatchable, loading, resendable, selectable } =
  toRefs(props);
const emit = defineEmits<{
  (event: 'cancel-spot-market'): void;
  (event: 'resend-spot-market'): void;
  (event: 'select-rate'): void;
}>();

const { t } = useI18n();

const actions = computed((): RygenMenuItem[] => [
  {
    key: 'SELECT_RATE',
    label: t('rateShop.select'),
    command: () => emit('select-rate'),
    requiredAuthorization: ['rateShop', 'selectRate'],
    visible: selectable.value && dispatchable.value,
  },
  {
    key: 'RESEND_SPOT_MARKET',
    label: t('common.resend'),
    command: () => emit('resend-spot-market'),
    visible: resendable.value,
  },
  {
    key: 'CANCEL_SPOT_MARKET',
    label: t('common.cancel'),
    severity: Severity.DANGER,
    command: () => emit('cancel-spot-market'),
    visible: cancellable.value,
  },
]);
</script>
